import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ProjectForm from '../project/projectForm';
import Config from '../config/config';
import ConfigTable from '../configTable/configTable';
import TaskUploadTable from '../uploadTask/taskUploadTable';
import AnalyticsMain from '../analytics/analyticsMain';
import { useDispatch } from 'react-redux';
import { getProject, setCloneProjectConfigStatus, setCloneProjectStageStatus } from '../../redux/slices/projectSlice/addProjectSlice';
import { AppDispatch } from '../../redux/store/appStore';
import { Divider, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store/appStore';
import UserTabOptions from '../projectUser/UserTabOptions';
import ProjectListHeading from './projectListHeading';
import { STATUS } from '../../utils/status';
import TestTabOptions from '../projectTest/testTabOptions';
import ReviewList from '../reviewer/reviewList';
import SnackbarNotification from '../snackbar/snackbarNotification';
import WorkflowMain from '../Workflow/workflowMain';
import HistoryLogs from '../HistoryLogs/HistoryLogs';
import GlobalFeedback from '../feedback/GlobalFeedback';

const ProjectTab = () => {
  const getStatus = useSelector((state: RootState) => state.projects.getStatus);
  const [alignment, setAlignment] = useState('task');
  const [userSubTab, setUserSubTab] = useState('tasker');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error" | "info" | "warning">("success");
  const [showConfigForm, setShowConfigForm] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  const fetchPermissions = useSelector((state: RootState) => state.projects.permissions);
  const association_type = useSelector((state: RootState) => state.projects.association_type);
  const projectData = useSelector((state: RootState) => state.projects);
  const association_type_company = association_type && association_type === 'COMPANY';
  const association_type_vendor = association_type && association_type === 'VENDOR';
  const [testSubTab, setTestSubTab] = useState(association_type_vendor ? 'attempts' : 'questions');
  const cloneConfigStatus = useSelector((state: RootState) => state.projects.cloneConfigStatus);
  const cloneStageStatus = useSelector((state: RootState) => state.projects.cloneStageStatus);
  const cloneProjectConfigMessage = useSelector((state: RootState) => state.projects.cloneProjectConfigMessage);
  const cloneProjectStageMessage = useSelector((state: RootState) => state.projects.cloneProjectStageMessage);



  useEffect(() => {
    if (getStatus === STATUS.SUCESS) {
      const params = new URLSearchParams(location.search);
      const tab = params.get('tab') || 'task';
      // const userTab = params.get('userTab') || 'expert';
      const testTab = params.get('testTab') || (association_type_vendor ? 'attempts' : 'questions');
      const userTab = params.get('userTab') || 'tasker';

      setAlignment(tab);
      setUserSubTab(userTab);
      setTestSubTab(testTab);

      if (association_type_vendor) {
        if (params.get('tab') !== null) {
          if (['edit', 'config', 'payment', 'reviewer'].includes(params.get('tab') || '')) {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', 'task');
            navigate(`${url.pathname}${url.search}`, { replace: true });
            setAlignment('task');
          }
        }
      }

      if (association_type_company) {
        const fetchPermissionsProjectTrue = Object.keys(fetchPermissions)
          .filter(key => fetchPermissions[key][0] === true && key.startsWith('project_') || key === 'review_stage')
          .map(key => key.replace('project_', '')).map(key => key === 'users' ? 'user' : key === 'review stages' || key === 'review_stage' ? 'review' : key === 'details' ? 'edit' : key === 'payments' ? 'payment' : key)

        // if (params.get('tab') !== null) {
        //   if (
        //     !fetchPermissionsProjectTrue.includes(params.get('tab') || '')
        //   ) {
        //     const url = new URL(window.location.href);
        //     url.searchParams.set('tab', 'task');
        //     navigate(`${url.pathname}${url.search}`, { replace: true });
        //     setAlignment('task');
        //   }
        // }
      }
    }

  }, [location.search, getStatus]);

  const handleChangeToggle = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      navigate(`/project/${id}?tab=${newAlignment}`);
    }
  };

  const handleUserSubTabChange = (event: React.MouseEvent<HTMLElement>, newSubTab: string) => {
    if (newSubTab) {
      setUserSubTab(newSubTab);
      navigate(`/project/${id}?tab=user&userTab=${newSubTab}`);
    }
  };

  const handleTestSubTabChange = (
    event: React.MouseEvent<HTMLElement>,
    newSubTab: string
  ) => {
    if (newSubTab !== null) {
      setTestSubTab(newSubTab);
      navigate(`/project/${id}?tab=test&testTab=${newSubTab}`);
    }
  };

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleAddConfigClick = () => {
    setShowConfigForm(true);
  };

  const handleSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning"
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };



  useEffect(() => {
    const handleCloneStatus = () => {
      if (cloneConfigStatus === STATUS.SUCESS) {
        handleSnackbar(!!cloneProjectConfigMessage ? cloneProjectConfigMessage : 'Project Configs Cloned Successfully', 'success');
        // handleProjectCloneClose();
      }
      if (cloneConfigStatus === STATUS.FAILED) {
        handleSnackbar(!!cloneProjectConfigMessage ? cloneProjectConfigMessage : 'Failed', "error");
      }
    };

    handleCloneStatus();
    return () => {
      if (
        cloneConfigStatus === STATUS.SUCESS ||
        cloneConfigStatus === STATUS.FAILED
      ) {
        dispatch(setCloneProjectConfigStatus(STATUS.NOT_STARTED));
      }
    };
  }, [cloneConfigStatus]);

  useEffect(() => {
    const handleCloneStatus = () => {
      if (cloneStageStatus === STATUS.SUCESS) {
        handleSnackbar(!!cloneProjectStageMessage ? cloneProjectStageMessage : 'Project Stages Cloned Successfully', 'success');
        // handleProjectCloneClose();
      }
      if (cloneStageStatus === STATUS.FAILED) {
        handleSnackbar(!!cloneProjectStageMessage ? cloneProjectStageMessage : 'Failed', "error");
      }
    };

    handleCloneStatus();
    return () => {
      if (
        cloneStageStatus === STATUS.SUCESS ||
        cloneStageStatus === STATUS.FAILED
      ) {
        dispatch(setCloneProjectStageStatus(STATUS.NOT_STARTED));
      }
    };
  }, [cloneStageStatus]);


  useEffect(() => {
    if (id) {
      dispatch(getProject({
        project_id: id,
        fields: JSON.stringify(['name', 'description', 'status', 'data_category', 'annotation_method.id', 'annotation_method.value', 'annotation_method.name', 'task_category.id',
          'task_category.value', 'task_category.name', 'task_category.data_category', 'task_category.annotation_method', 'ideal_task_time', 'ideal_review_time', 'created_at',
          'auto_submit_task', 'reviewer_setting', 'review_setting', 'max_user_per_task', 'task_guidelines', 'expert_guidelines', 'reviewer_guidelines', 'test_guidelines', 'split_screen', 'test_time', 'test_max_attempts', 'test_passing_score_percentage',
          'auto_allocate_task_count', 'enable_question_randomization', 'enable_question_shuffling', 'enable_options_shuffling', 'test_question_count', 'is_test_enabled', 'test_question_distribution', 'enable_draft_tasks', 'allow_edit_in_draft'
        ])
      }));
    }
  }, [id]);

  const isTestEnable = projectData?.project?.is_test_enabled

  return (
    <>
      <div style={{ width: '100vw', overflow: 'hidden' }}>
        <Box sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '0rem' }}>
          <ProjectListHeading />
        </Box>
        <Divider />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '1rem' }}>
          <Paper sx={{
            bgcolor: '#FFFFFF',
            borderRadius: '8px',
            padding: '1rem',
            mb: '2rem',
            boxShadow: 2,
          }}>
            <div
              style={{
                borderBottom: '1px solid',
                borderColor: '  ',
                margin: 2,
                padding: '0px, 24px, 0px, 24px',
              }}
            >
              <ToggleButtonGroup
                color="standard"
                value={alignment}
                exclusive
                onChange={handleChangeToggle}
              >
                {association_type_company && fetchPermissions.project_details?.[0] &&
                  <ToggleButton
                    value="edit"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'edit' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'edit' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Edit Project
                  </ToggleButton>
                }
                {association_type_company && fetchPermissions.project_analytics?.[0] &&
                  <ToggleButton
                    value="analytics"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'analytics' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'analytics' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Analytics
                  </ToggleButton>
                }
                {association_type_vendor && fetchPermissions.project_analytics?.[0] &&
                  <ToggleButton
                    value="analytics"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'analytics' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'analytics' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Analytics
                  </ToggleButton>
                }
                <ToggleButton
                  value="task"
                  style={{
                    border: 'none',
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: '24px',
                    color: alignment === 'task' ? '#03BBD2' : '#6C6C6C',
                    borderBottom: alignment === 'task' ? '3px solid #03BBD2' : 'none',
                    backgroundColor: 'inherit',
                    textTransform: 'none'
                  }}
                >
                  Task
                </ToggleButton>
                {association_type_company && fetchPermissions.project_config?.[0] &&
                  <ToggleButton
                    value="config"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'config' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'config' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Config
                  </ToggleButton>
                }
                {association_type_company && fetchPermissions.project_users?.[0] &&
                  <ToggleButton
                    value="user"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'user' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'user' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Users
                  </ToggleButton>
                }
                {association_type_vendor &&
                  <ToggleButton
                    value="user"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'user' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'user' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Users
                  </ToggleButton>
                }
                {/* <ToggleButton
                value="access"
                style={{
                  border: 'none',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '24px',
                  color: alignment === 'access' ? '#03BBD2' : '#6C6C6C',
                  borderBottom: alignment === 'access' ? '3px solid #03BBD2' : 'none',
                  backgroundColor: 'inherit',
                  textTransform: 'none'
                }}
              >
                API Access
              </ToggleButton> */}


                {association_type_company && fetchPermissions.project_test?.[0] &&
                  <ToggleButton
                    value="test"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'test' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'test' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Test
                  </ToggleButton>
                }

                {association_type_vendor && fetchPermissions.project_test?.[0] &&
                  <ToggleButton
                    value="test"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'test' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'test' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Test
                  </ToggleButton>
                }

                {fetchPermissions?.review_stage?.[0] && association_type_company && (
                  <ToggleButton
                    value="review"
                    disabled={fetchPermissions?.reviewer_stage?.[0] === false}
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'review' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'review' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Stages
                  </ToggleButton>
                )}

                {association_type_company &&
                  <ToggleButton
                    value="workflow"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'workflow' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'workflow' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Stages workflow
                  </ToggleButton>
                }

                  <ToggleButton
                    value="feedback"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'feedback' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'feedback' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    Global Feedback
                  </ToggleButton>

                {association_type_company &&
                  <ToggleButton
                    value="historyLogs"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: alignment === 'historyLogs' ? '#03BBD2' : '#6C6C6C',
                      borderBottom: alignment === 'historyLogs' ? '3px solid #03BBD2' : 'none',
                      backgroundColor: 'inherit',
                      textTransform: 'none'
                    }}
                  >
                    History / Logs
                  </ToggleButton>
                }
                
                {/* <ToggleButton
                value="modal"
                style={{
                  border: 'none',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '24px',
                  color: alignment === 'modal' ? '#03BBD2' : '#6C6C6C',
                  borderBottom: alignment === 'modal' ? '3px solid #03BBD2' : 'none',
                  backgroundColor: 'inherit',
                  textTransform: 'none'
                }}
              >
                Modal Integration
              </ToggleButton> */}
              </ToggleButtonGroup>
            </div>

            {alignment === 'user' && (
              <ToggleButtonGroup
                color="standard"
                value={userSubTab} exclusive onChange={handleUserSubTabChange}
              >
                <div style={{ border: "1px solid lightgrey", borderRadius: "15px", marginTop: "10px", padding: "5px 5px 5px 5px" }}>
                  <ToggleButton
                    value="tasker"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: userSubTab === 'tasker' ? '#fff' : '#6C6C6C',
                      borderRadius: "15px",
                      backgroundColor: userSubTab === 'tasker' ? '#03BBD2' : '#fff',
                      textTransform: 'none',
                      marginRight: "5px"
                    }}
                  >
                    Tasker
                  </ToggleButton>

                  <ToggleButton
                    value="reviewer"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: userSubTab === 'reviewer' ? '#fff' : '#6C6C6C',
                      borderRadius: "15px",
                      backgroundColor: userSubTab === 'reviewer' ? '#03BBD2' : '#fff',
                      textTransform: 'none',
                      marginRight: "5px"
                    }}
                  >
                    Reviewer
                  </ToggleButton>

                  {!association_type_vendor &&
                    <ToggleButton
                      value="vendor"
                      style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: userSubTab === 'vendor' ? '#fff' : '#6C6C6C',
                        borderRadius: "15px",
                        backgroundColor: userSubTab === 'vendor' ? '#03BBD2' : '#fff',
                        textTransform: 'none',
                        marginRight: "5px"

                      }}
                    >
                      Vendors
                    </ToggleButton>
                  }
                  <ToggleButton
                    value="admin"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: userSubTab === 'admin' ? '#fff' : '#6C6C6C',
                      borderRadius: "15px",
                      backgroundColor: userSubTab === 'admin' ? '#03BBD2' : '#fff',
                      textTransform: 'none'
                    }}
                  >
                    Admins
                  </ToggleButton>
                </div>
              </ToggleButtonGroup>
            )}

            {association_type_company && fetchPermissions.project_details?.[0] && alignment === 'edit' && (
              <div style={{ marginTop: '20px' }}>
                <ProjectForm />
              </div>
            )}

            {
              (
                (
                  (
                    association_type_company &&
                    fetchPermissions.project_analytics[0]
                  ) ||
                  (
                    association_type_vendor &&
                    fetchPermissions.project_analytics[0]
                  )
                ) &&
                alignment === 'analytics'
              )
                ?
                <div style={{ marginTop: '20px' }}>
                  <AnalyticsMain />
                </div>
                : <></>
            }

            {alignment === 'task' && (
              <div>
                <TaskUploadTable />
              </div>
            )}

            {association_type_company && fetchPermissions.project_config?.[0] && alignment === 'config' && (
              <div>
                {showConfigForm ? <Config /> : <ConfigTable onAddConfigClick={handleAddConfigClick} />}
              </div>
            )}

            {((association_type_vendor || (association_type_company && fetchPermissions.project_users?.[0])) && alignment === 'user') &&
              <UserTabOptions userTab={userSubTab} />
            }

            {/* {alignment === 'access' && (
            <div>
              <Typography sx={{marginTop:'10px'}}>Project ID: {formattedId}</Typography>
            </div>
          )} */}

            {/* {alignment === 'modal' && (
              <div>
                <IntegrationForm />
              </div>
            )} */}
            {alignment === 'test' && association_type_company && (
              <>
                {isTestEnable === false ? <div style={{ backgroundColor: "skyblue", height: "30px", width: "100%", borderRadius: "5px" }}>
                  <Typography style={{ fontFamily: "montserrat", textAlign: "center", margin: "auto", paddingTop: "3px" }}>Test is currently disabled. To create, assign, or analyze test results,
                    please enable the test from the 'Test Control' section first!</Typography>
                </div> : <></>}
                <ToggleButtonGroup
                  color="standard"
                  value={testSubTab} exclusive onChange={handleTestSubTabChange}
                >
                  <div style={{ border: "1px solid lightgrey", borderRadius: "15px", marginTop: "10px", padding: "5px 5px 5px 5px" }}>
                    <ToggleButton
                      value="questions"
                      style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: testSubTab === 'questions' ? '#fff' : '#6C6C6C',
                        borderRadius: "15px",
                        backgroundColor: testSubTab === 'questions' ? '#03BBD2' : '#fff',
                        textTransform: 'none',
                        marginRight: "5px"
                      }}
                    >
                      Test Setup
                    </ToggleButton>
                    <ToggleButton
                      value="control"
                      style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: testSubTab === 'control' ? '#fff' : '#6C6C6C',
                        borderRadius: "15px",
                        backgroundColor: testSubTab === 'control' ? '#03BBD2' : '#fff',
                        textTransform: 'none',
                        marginRight: "5px"
                      }}
                    >
                      Test Control
                    </ToggleButton>
                    {!association_type_vendor &&
                      <ToggleButton
                        value="attempts"
                        style={{
                          border: 'none',
                          fontFamily: 'Montserrat',
                          fontSize: '14px',
                          fontWeight: 600,
                          lineHeight: '24px',
                          color: testSubTab === 'attempts' ? '#fff' : '#6C6C6C',
                          borderRadius: "15px",
                          backgroundColor: testSubTab === 'attempts' ? '#03BBD2' : '#fff',
                          textTransform: 'none',
                          marginRight: "5px"

                        }}
                      >
                        Attempts
                      </ToggleButton>
                    }
                    {/* <ToggleButton
                    value="analysis"
                    style={{
                      border: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: testSubTab === 'analysis' ? '#fff' : '#6C6C6C',
                      borderRadius: "15px",
                      backgroundColor: testSubTab === 'analysis' ? '#03BBD2' : '#fff',
                      textTransform: 'none'
                    }}
                  >
                    Analysis
                  </ToggleButton> */}
                  </div>
                </ToggleButtonGroup>
              </>
            )}

            {(alignment === 'test') && fetchPermissions?.project_test && <TestTabOptions testTab={testSubTab} />}
            {alignment === 'workflow' && !association_type_vendor && (<div><WorkflowMain /></div>)}
            {(alignment === 'review') && !association_type_vendor && <ReviewList />}
            {(alignment === 'feedback') && (<GlobalFeedback />)}
            {(alignment === 'historyLogs') && !association_type_vendor && (<div><HistoryLogs /></div>)}
          </Paper>
        </Box>
      </div>

      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
}

export default ProjectTab;
